<template>
    <el-dialog :title="subject"
               :visible.sync="showDialog"
               @open="loadTicket"
               @close="closeDialog"
               width="650px"
               append-to-body
               :close-on-click-modal="false">
        <div v-html="body">

        </div>
    </el-dialog>
        
</template>
<script>
    export default {
        name: "email-details-dialog",
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            ticketId: {
                required: true
            },
            subject: {
                required: true
            },
            body: {
                required: true
            }
        },
        data() {
            return {
                showDialog: this.visible,
            }
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            }
        },
        methods: {
            loadTicket() {
                console.log("Load Ticket")
            },
            closeDialog() {
                this.showDialog = false;
                this.$emit("dialogClosed");
            }
        }
    }
</script>


// WEBPACK FOOTER //
// ClientApp/app/emails/components/emailDetailsDialog.vue